<div class="lista">
  <!-- Mostro le variabili del impatto -->
  @if (tipoIro === 'impatto') {
    <div class="titolo-tooltip">Variabili Impatto</div>
    <ul>
      @if (iro.impattoPotenzialeEffettivo) {
        <li>
          {{ iro.impattoPotenzialeEffettivo }}
        </li>
      }

      @if (iro.impattoPositivoNegativo) {
        <li>
          {{ iro.impattoPositivoNegativo }}
        </li>
      }

      @if (iro.impattoDirettoIndiretto.length) {
        @for (impDirettoIndiretto of iro.impattoDirettoIndiretto; track $index) {
          <li>
            {{ impDirettoIndiretto }}
          </li>
        }
      }
    </ul>
  } @else {
    <!-- Mostro le variabili dei rischi e delle opportunità -->
    @if (iro.fonte) {
      <div class="titolo-tooltip">Fonte</div>
      <ul>
        <li>
          {{ iro.fonte }}
        </li>
      </ul>
    }

    @if (iro.catene.length) {
      <div class="titolo-tooltip">Punto della catena del valore dove si genera</div>
      <ul>
        @for (catena of iro.catene; track $index) {
          <li>
            {{ upperToLowerCase(catena) }}
          </li>
        }
      </ul>
    }
  }

  <!-- Mostro la variabile comnuni a tutti gli IRO -->
  @if (iro.orizzontiTemporali.length) {
    <div class="titolo-tooltip">Orizzonte temporale</div>
    <ul>
      @for (orizz of iro.orizzontiTemporali; track $index) {
        <li>
          {{ upperToLowerCase(orizz) }}
        </li>
      }
    </ul>
  }
</div>
